export default {
  data() {
    return {
      delay: 300,
      manager: this.$services.resolve('liveManager'),
      timeout: null,
      dragging: false,
    };
  },
  methods: {
    onDragStart() {
      this.dragging = true;
      this.hidePopover();
    },
    onDragStop() {
      this.dragging = false;
    },
    showPopover(e) {
      if (this.dragging) {
        return;
      }

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const $program = e.target.closest('.js-epg-program-item');

        if ($program && this.$refs.popover) {
          const programID = $program.getAttribute('program-id');
          const program = this.manager.programs.get(programID);

          this.$refs.popover.show(program, $program);
        }
      }, this.delay);
    },
    hidePopover() {
      clearTimeout(this.timeout);
      this.$refs.popover && this.$refs.popover.hide();
    },
  },
};
